import { takeEvery, put, call } from "redux-saga/effects";
import { UPDATE_PROFILE, VIEW_PROFILE } from "./actionTypes";
import {
  updateProfileSuccess,
  updateProfileError,
  viewProfileError,
  viewProfileSuccess,
} from "./actions";
import { getViewProfile, postUpdateProfile } from "../../../helpers/api";
import { togglePageLoader } from "../../actions";
import { notifications } from "@mantine/notifications";

function* updateProfile({ payload: data, callback }) {
  try {
    yield put(togglePageLoader(true));
    const response = yield call(postUpdateProfile, data);
    if (response.statusCode == 1) {
      yield put(updateProfileSuccess(response));
      notifications.show({color: "lime",  message: response.message });
      yield put(togglePageLoader(false));
      callback("Success");
    } else {
      notifications.show({ color: "red", message: response.message });
      callback("Failure");
      yield put(updateProfileError(response));
      yield put(togglePageLoader(false));
      // notifications.show({ message: response.title || response.message });
    }
  } catch (error) {}
}

function* viewProfile({ payload: userId, callback }) {
  try {
    const response = yield call(getViewProfile, userId);
    if (response.status == "Success") {
      callback("SUCCESS");
      yield put(viewProfileSuccess(response));
    } else {
      yield put(viewProfileError(response));
      callback("FAILURE");
    }
  } catch (error) {}
}

function* updateProfileSaga() {
  yield takeEvery(UPDATE_PROFILE, updateProfile);
  yield takeEvery(VIEW_PROFILE, viewProfile);
}

export default updateProfileSaga;
